/* Stienhardt - diamond PDP gallery photo counter "n / N" (2026-06-26)
   Signals there are more photos to swipe. Top-right pill, updates on swipe,
   hidden on the 360 slide (that slide has its own viewer UI / X). Mobile focus
   but harmless on desktop. Revert = remove this file + its <script>. */
(function () {
  'use strict';
  function init() {
    var g = document.querySelector('.diamond-product-template .product-media-gallery');
    if (!g || !g.swiper) return false;
    var sw = g.swiper;
    var slides = sw.slides ? sw.slides.length : 0;
    if (slides < 2) return true;
    if (g.querySelector('.sp-gallery-count')) return true;
    try { g.style.position = 'relative'; } catch (e) {}
    var c = document.createElement('div');
    c.className = 'sp-gallery-count';
    g.appendChild(c);
    function upd() {
      var i = (typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex) || 0;
      c.textContent = (i + 1) + ' / ' + slides;
      var active = sw.slides[sw.activeIndex];
      c.style.display = (active && active.classList && active.classList.contains('video-slide')) ? 'none' : 'block';
    }
    upd();
    sw.on('slideChange', upd);
    sw.on('slideChangeTransitionEnd', upd);
    return true;
  }
  var n = 0, iv = setInterval(function () { n++; if (init() || n > 40) clearInterval(iv); }, 300);
})();
